import React from "react";
import MapContainer from "../MapContainer";

export default function GoogleMapProvider(props) {
  return <MapContainer {...props} />;
}
